import { cva } from 'class-variance-authority';

export const strateNavigationButtonCVA = cva(
  [
    'border-none z-50 absolute',
    'bg-dt-background-button-icon-v2-button-icon-filled-quaternary',
    'hover:bg-dt-background-button-icon-v2-button-icon-filled-quaternary-hover',
    'transition-all flex items-center justify-center',
    // use the center as anchor point for vertical positioning
    '-translate-y-1/2',
  ],
  {
    variants: {
      size: {
        xxs: 'p-dt-spacing-50 rounded-dt-radius-small',
        xs: 'p-dt-spacing-75 rounded-dt-radius-small',
        sm: 'p-dt-spacing-75 rounded-dt-radius-small',
        md: 'p-dt-spacing-100 rounded-dt-radius-medium',
        lg: 'p-dt-spacing-100 rounded-dt-radius-medium',
        xlg: 'p-dt-spacing-150 rounded-dt-radius-medium',
      },
      direction: {
        right: 'right-8',
        left: 'left-8',
      },
      verticalAlign: {
        middle: 'top-1/2',
        top: 'top-0',
      },
      isHidden: {
        true: 'opacity-0 pointer-events-none',
        false: 'opacity-100 hover:opacity-80 cursor-pointer',
      },
    },
  },
);

export const strateNavigationButtonIconCVA = cva(
  ['fill-dt-icon-button-icon-v2-button-icon-filled-quaternary'],
  {
    variants: {
      size: {
        xxs: 'size-[1rem]',
        xs: 'size-[1rem]',
        sm: 'size-[1.25rem]',
        md: 'size-[1.5rem]',
        lg: 'size-[2rem]',
        xlg: 'size-[2.5rem]',
      },
      direction: {
        right: 'rotate-180',
        left: '',
      },
    },
  },
);
